export default __webpack_public_path__ + "static/media/order-management.702393f1.svg";